import Vue from 'vue';
import Router from 'vue-router';
// import { IsPC, IsInviteMode } from '@/utils/tool';

Vue.use(Router);

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Invite/invite_red.vue'),
      // component: () => import(/* webpackChunkName: "about" */ '@/views/Home/Home.vue'),
      // component: () => {
      //   if (IsInviteMode()) {
      //     return import(/* webpackChunkName: "about" */ '@/views/Invite/invite.vue');
      //   }
      //   if (!IsPC()) {
      //     return import(/* webpackChunkName: "about" */ '@/views/Home/mobileHome.vue');
      //   }
      //   return import(/* webpackChunkName: "about" */ '@/views/Home/Home.vue');
      // },
    },
    // {
    //   path: '/home',
    //   redirect: '/',
    // }, {
    //   path: '/product',
    //   redirect: '/',
    // }, {
    //   path: '/faq',
    //   redirect: '/',
    // }, {
    //   path: '/aboutUs',
    //   redirect: '/',
    // },
    // {
    //   path: '/register',
    //   component: () => import('@/views/ADpage/adpage.vue'),
    // },
    // {
    //   path: '/dlregister',
    //   component: () => import('@/views/DLpage/adpage.vue'),
    // },
    // {
    //   path: '/policy',
    //   component: () => import('@/views/ADpage/policy.vue'),
    // },
    // {
    //   path: '/invite',
    //   component: () => import('@/views/Invite/invite.vue'),
    // },
    {
      path: '/invite_new',
      component: () => import('@/views/Invite/invite_red.vue'),
    },
    {
      path: '/CS/:month',
      component: () => import('@/views/ThreatSMS/index.vue'),
    },
    {
      path: '/CSMobile/:month',
      component: () => import('@/views/ThreatSMS/index_mobile.vue'),
    },
  ],
});
